import React, { useState } from "react";

export default function SchoolBrand({ compact = false }) {
  const [src, setSrc] = useState("/school-logo.png");
  const [failed, setFailed] = useState(false);

  const handleError = () => {
    if (src !== "/logo512.png") {
      setSrc("/logo512.png");
      return;
    }
    setFailed(true);
  };

  return (
    <div className={compact ? "dash-brand compact" : "dash-brand"}>
      {!failed ? (
        <img
          src={src}
          alt="School Logo"
          className={compact ? "dash-brand-logo compact" : "dash-brand-logo"}
          onError={handleError}
        />
      ) : (
        <>
          MPIPS<small>TM</small>
        </>
      )}
    </div>
  );
}
